import Link from "next/link";

const BreadcrumbItem = ({ children, href, active = false }) => {
  return active ? (
    <li aria-current="page" className="active breadcrumb-item">
      <span className="paragraph-sm text-gray-600">{children}</span>
    </li>
  ) : (
    <li className="breadcrumb-item">
      <a href={href} className="paragraph-sm text-gray-600">
        {children}
      </a>
    </li>
  )
}

export default BreadcrumbItem
